var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankBalanceMaximum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#20A74E",
    fillOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7944 35.9585C47.8185 34.4864 48.4367 32.7705 48.5869 30.9835C48.737 29.1965 48.4138 27.4014 47.6497 25.7791C46.8856 24.1567 45.7076 22.7643 44.2343 21.7419C42.7609 20.7195 41.0443 20.1033 39.2571 19.9553C37.47 19.8072 35.6753 20.1326 34.0539 20.8986C32.4324 21.6646 31.0413 22.8442 30.0207 24.3188C29.0001 25.7933 28.3859 27.5106 28.2399 29.298C28.094 31.0853 28.4215 32.8796 29.1894 34.5002",
    stroke: "#20A74E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4167 25.7503C36.8052 25.7503 35.5 26.7303 35.5 27.9378C35.5 29.1453 36.8052 30.1253 38.4167 30.1253C40.0281 30.1253 41.3333 31.1053 41.3333 32.3128C41.3333 33.5203 40.0281 34.5003 38.4167 34.5003M38.4167 25.7503C39.6854 25.7503 40.7675 26.3585 41.1671 27.2087M38.4167 25.7503V24.292M38.4167 34.5003C37.1479 34.5003 36.0658 33.8922 35.6662 33.042M38.4167 34.5003V35.9587M22.375 37.417H25.8677C26.2965 37.417 26.7194 37.5132 27.1029 37.6999L30.0808 39.1407C30.4644 39.326 30.8873 39.4222 31.3175 39.4222H32.8371C34.3071 39.4222 35.5 40.5757 35.5 41.9991C35.5 42.0574 35.4606 42.107 35.4037 42.123L31.6981 43.1482C31.0332 43.3319 30.3242 43.2677 29.7031 42.9674L26.5196 41.4274M35.5 41.0628L42.1981 39.0051C42.7812 38.8262 43.406 38.836 43.9832 39.0332C44.5604 39.2304 45.0605 39.6049 45.4123 40.1032C45.9504 40.847 45.7317 41.9145 44.9471 42.3666L33.9877 48.6914C33.645 48.8896 33.2656 49.0161 32.8724 49.063C32.4793 49.1098 32.0807 49.0762 31.701 48.9641L22.375 46.1962",
    stroke: "#20A74E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBalanceMaximum);
export default __webpack_public_path__ + "static/media/BankBalanceMaximum.4c5b54789612aad303c852cce65692db.svg";
export { ForwardRef as ReactComponent };